import React, { useEffect, useState } from "react";

import { View, ScrollView } from "react-native";

import {
  Text,
  Toast,
  Cover,
  Header,
  Button,
  Separator,
  InputLabel,
  LoadingBox,
  ConfirmAlert,
  ProductPicker,
  ParentCatPicker,
  DeleteAlertComponent,
  Modal,
  TextArea,
} from "components";
import Counter from "../items/factorItemCard/Counter";
import AttributesSingleSelector from "./AttributesSingleSelector";

import {
  persianDigit,
  changeArrayAt,
  isEqualArrays,
  removeArrayItemAt,
} from "utils";
import { colors, sizes, strings } from "assets/constants";
import { factorItemsAtom } from "stores";
import { useRecoilState } from "recoil";
import css from "styles";

import { useVariantProductAttributes } from "clients/apis";
import tinycolor from "tinycolor2";
import DraftItems from "./DraftItems";
import { useChangeStepFlags } from "../hooks/useChangeStepFlags";
import { _goToBack } from "routers/helper";
import { useFlag } from "hooks";
import toast from "components/toast";

const AddNewFactorItems = () => {
  const { goToCountEditingMode } = useChangeStepFlags();

  const [factorItems, setFactorItems] = useRecoilState(factorItemsAtom);
  const [indexToBeRemoved, setIndexToBeRemoved] = useState(-1);
  const [counterStep, setCounterStep] = useState(1);
  const [binariesVars, setBinariesVars] = useState([]);
  const [tmpVar, setTmpVar] = useState<{
    attrs: Array<FactorItemAttrT>;
    item_description: string;
    is_binary: 0 | 1;
    count: number;
  }>(null);

  const { flg: descModal, on: showDescModal, off: hideDescModal } = useFlag();

  const [fields, setFields] = useState<FactorItemT>();
  const updateFields = (newVal: FactorItemT) =>
    setFields((prev) => ({ ...prev, ...newVal }));

  const {
    data: variationsAndAttributes,
    isLoading: fetchVariationAndAttributesLoading,
  } = useVariantProductAttributes({
    productId: fields?.product?.id,
    categoryId: fields?.category?.id,
  });

  const variationsPrice = (
    vars: any
  ): Array<{ ids: Array<number>; price: number }> => {
    return vars?.map((variation: any) => {
      return {
        price: variation.price,
        ids: variation?.attributes?.map((a: any) => a.id),
      };
    });
  };

  useEffect(() => {
    if (variationsAndAttributes) {
      variationsAndAttributes?.data?.product?.variations?.map(
        (e: ProductVariationT) => {
          if (e?.is_binary === 1) {
            const newVars = e?.attributes
              ?.map((a) => a.id)
              .sort()
              .toString();
            setBinariesVars((prev) =>
              !prev.includes(newVars) ? [...prev, newVars] : prev
            );
          }
        }
      );
    }
  }, [variationsAndAttributes]);

  const _onChangeCategory = (input?: PickerItemT) => {
    const category = input as CategoryT;
    updateFields({ category, product: null });
    setBinariesVars([]);
    setTmpVar(null);
  };

  const selectProductWarn = () =>
    Toast.warning({ message: strings.pick_product_cat_for_first });

  const _onChangeProduct = (input?: PickerItemT) => {
    const product = input as ProductT;
    updateFields({ product, attributes: undefined });
    setBinariesVars([]);
    setTmpVar(null);
  };

  const _onChangeAttributes = (input: Array<FactorItemAttrT>) => {
    const varIds = input?.map((e) => e.id);
    let varIndex = -1;

    factorItems?.map((item: FactorItemT, index: number) => {
      if (item?.status?.priority !== 1) {
        return;
      }

      if (
        fields?.product?.type === "normal" &&
        item.product.id === fields.product.id
      ) {
        varIndex = index;
      }

      if (
        fields?.product?.type === "variable" &&
        item?.product?.id === fields?.product?.id &&
        isEqualArrays(item?.attributes?.map((a) => a.id) || [], varIds)
      ) {
        varIndex = index;
      }
    });

    if (varIndex > -1) {
      setTmpVar({
        attrs: input,
        count: +factorItems[varIndex].count,
        item_description: "",
        is_binary: factorItems[varIndex].product.is_binary,
      });
    } else {
      setTmpVar({
        attrs: input,
        count: 1,
        item_description: "",
        is_binary: binariesVars?.includes(
          input
            ?.map((e) => e.id)
            .sort()
            .toString()
        )
          ? 1
          : 0,
      });
    }
  };

  const _onSubmit = () => {
    const hasCustomizedAttr = tmpVar?.attrs?.some((e) => e.is_customized === 1);
    if (hasCustomizedAttr && !tmpVar.item_description) {
      toast.warning({ message: "توضیحات مربوط به محصول را وارد نمایید" });
      return;
    }

    goToCountEditingMode();

    const existsItems = factorItems?.map((factorItem) => {
      return {
        pId: factorItem.product?.id,
        vars: factorItem.attributes?.map((attr) => attr?.id),
      };
    });

    if (fields) {
      const { category, product } = fields;

      if (product?.type === "normal") {
        const productIndex = existsItems.findIndex(
          (e) => fields.product?.id === e.pId
        );

        let newItem: FactorItemT;
        let tmp = [...factorItems];
        if (productIndex > -1) {
          const thisItem = tmp[productIndex];
          const newCount = tmpVar?.count;
          const newTotalPrice = newCount * Number(tmp[productIndex].price);

          const newThisItem: FactorItemT = {
            ...thisItem,
            count: newCount,
            total_price: newTotalPrice,
          };

          tmp = changeArrayAt(tmp, productIndex, newThisItem);
        } else {
          newItem = {
            id: -1 * Date.now(),
            category,
            product,
            item_description: "",
            attributes: [],
            count: tmpVar?.count,
            price: product.price,
            total_price: tmpVar?.count && product.price * tmpVar?.count,
            status: { id: "DRAFT", priority: 1, title: "", changeable: true },
          };
        }

        const result = newItem ? [...tmp, newItem] : [...tmp];

        setFactorItems(result);
      } else {
        let productIndex = -1;
        const varIds = tmpVar?.attrs?.map((e) => e.id);

        factorItems?.map((item: FactorItemT, index: number) => {
          if (
            item?.status?.priority === 1 &&
            item?.product?.id === fields?.product?.id &&
            isEqualArrays(item?.attributes?.map((a) => a.id) || [], varIds)
          ) {
            productIndex = index;
          }
        });

        let newItem: FactorItemT;
        let tmp = [...factorItems];
        if (productIndex > -1) {
          const thisItem = tmp[productIndex];
          const newCount = tmpVar?.count;
          const newTotalPrice = newCount * Number(tmp[productIndex].price);
          const newItemDescription = tmpVar.item_description.replace(
            "\n",
            " - "
          );
          const newThisItem: FactorItemT = {
            ...thisItem,
            count: newCount,
            total_price: newTotalPrice,
            item_description: newItemDescription,
          };

          tmp = changeArrayAt(tmp, productIndex, newThisItem);
        } else {
          const itemPrice = variationsPrice(
            variationsAndAttributes?.data?.product?.variations
          ).filter((v) => isEqualArrays(varIds, v.ids))?.[0]?.price;

          newItem = {
            id: -1 * Date.now(),
            category,
            product: {
              ...product,
              is_binary: tmpVar?.is_binary,
            },
            item_description: tmpVar.item_description?.replace("\n", " - "),
            attributes: tmpVar?.attrs,
            count: hasCustomizedAttr ? 1 : tmpVar?.count,
            price: hasCustomizedAttr ? 0 : product.price,
            total_price: hasCustomizedAttr
              ? 0
              : tmpVar?.count && itemPrice * tmpVar?.count,
            status: { id: "DRAFT", priority: 1, title: "", changeable: true },
          };
        }

        const result = newItem ? [...tmp, newItem] : [...tmp];

        setFactorItems(result);
      }
    }

    setTmpVar(null);
  };

  const _onRemoveItem = (close: () => void) => {
    const tmp = removeArrayItemAt([...factorItems], indexToBeRemoved);

    setFactorItems(tmp);
    close();
  };

  const _onConfirmDesc = () => {
    if (tmpVar.item_description.trim() === "") {
      toast.warning({ message: "توضیحات مربوط به محصول را وارد نمایید" });
      return;
    }

    hideDescModal();
  };

  const _onCancelDesc = () => {
    setTmpVar((prev) => ({ ...prev, item_description: "" }));
    hideDescModal();
  };

  const _renderContent = () => {
    return (
      <>
        <View style={css.responsiveInputContainer}>
          <InputLabel
            label={strings.product_cat}
            textProps={{ weight: "extraBold" }}
          />
          <ParentCatPicker
            onSelect={_onChangeCategory}
            showChild
            hideParents
            placeholder={strings.pick_product_cat}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel
            label={strings.product}
            textProps={{ weight: "extraBold" }}
          />
          <ProductPicker
            onSelect={_onChangeProduct}
            onPress={fields?.category ? undefined : selectProductWarn}
            id={fields?.category?.id}
            value={fields?.product}
          />
        </View>

        {fields?.product?.id && (
          <>
            {/* {groupSelectAttrs ? (
              <Button
                onPress={onDisableGroupSelectAttrs}
                square={45}
                icon={{ name: "x" }}
              />
            ) : (
              <Button
                onPress={onEnableGroupSelectAttrs}
                square={45}
                icon={{ name: "repeat" }}
              />
            )} */}

            <View style={css.fitWidth}>
              {fetchVariationAndAttributesLoading ? (
                <LoadingBox />
              ) : (
                // : groupSelectAttrs ? (
                //   <AttributesMultiSelector
                //     items={variationsAndAttributes?.data?.attributes}
                //     onChange={() => {}}
                //   />
                // )
                <AttributesSingleSelector
                  items={variationsAndAttributes?.data?.attributes}
                  onChange={_onChangeAttributes}
                  value={tmpVar?.attrs || []}
                />
              )}
            </View>

            <View style={css.fitWidth}>
              {tmpVar !== null && (
                <View
                  style={{
                    alignSelf: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    marginTop: sizes.space * 3,
                    marginBottom: sizes.space * 2,
                    borderRadius: sizes.radius.xl,
                    backgroundColor: colors.white,
                    padding: sizes.space,
                    borderWidth: 1,
                    borderColor: colors.lightBorder,
                  }}
                >
                  <View>
                    <Button
                      onPress={() => setTmpVar(null)}
                      square={35}
                      bgColor={colors.white}
                      icon={{ name: "x", color: colors.danger, size: 22 }}
                      style={{
                        marginRight: sizes.space,
                        marginBottom: sizes.space,
                      }}
                    />
                    <Button
                      square={35}
                      bgColor={colors.white}
                      icon={{ name: "check", color: colors.theme, size: 25 }}
                      style={{ marginRight: sizes.space * 2 }}
                      onPress={_onSubmit}
                    />
                  </View>

                  <View style={{ minWidth: 250 }}>
                    {tmpVar?.is_binary === 1 && (
                      <View
                        style={{
                          position: "absolute",
                          top: -25,
                          right: 2,
                          borderWidth: 1,
                          paddingHorizontal: 12,
                          borderRadius: 10,
                          backgroundColor: colors.white,
                          borderColor: colors.lightBorder,
                        }}
                      >
                        <Text
                          top={-1}
                          weight="extraBold"
                          color={colors.darkWarning}
                        >
                          جفتی
                        </Text>
                      </View>
                    )}
                    <View
                      style={{
                        alignSelf: "flex-end",
                        marginBottom: sizes.space,
                        height: 35,
                      }}
                    >
                      {fields?.product?.type === "variable" ? (
                        <View style={{ flexDirection: "row" }}>
                          {tmpVar?.attrs
                            ?.map((e) => e.title)
                            ?.map((t, key) => (
                              <Text key={String(key)} size={"lg"} weight="bold">
                                {" "}
                                {persianDigit(t)}{" "}
                              </Text>
                            ))}
                        </View>
                      ) : (
                        <Text weight="extraBold" size={"lg"}>
                          {fields?.product?.title}
                        </Text>
                      )}
                    </View>

                    <View style={{ alignSelf: "flex-end" }}>
                      {tmpVar?.attrs?.some((e) => e.is_customized === 1) ? (
                        <Button
                          onPress={showDescModal}
                          height={35}
                          title={{
                            value: tmpVar?.item_description
                              ? strings?.edit_description
                              : strings.add_description,
                            color: colors.theme,
                            weight: "bold",
                            size: "sm",
                          }}
                          bgColor={tinycolor(colors.theme)
                            .lighten(50)
                            .toString()}
                          icon={{
                            name: "commenting-o",
                            type: "fontAwesome",
                            color: colors.theme,
                          }}
                          contentSeparator={3}
                          style={{ paddingHorizontal: sizes.space }}
                        />
                      ) : (
                        <Counter
                          counterStep={tmpVar?.is_binary === 1 ? 2 : 1}
                          defaultValue={tmpVar.count}
                          onChange={(count) => {
                            setTmpVar((prev) => ({ ...prev, count }));
                          }}
                        />
                      )}
                    </View>
                  </View>
                </View>
              )}
            </View>

            <Modal visible={descModal} close={_onCancelDesc}>
              <ScrollView keyboardShouldPersistTaps="handled">
                <InputLabel
                  label={
                    strings.count_and_description_for_customized_attributes
                  }
                />
                <TextArea
                  value={tmpVar?.item_description}
                  onChangeText={(desc) =>
                    setTmpVar((prev) => ({ ...prev, item_description: desc }))
                  }
                  placeholder={strings.insert_customized_attributes_description}
                  icon={{ name: "list" }}
                />
                <View
                  style={{
                    ...css.paddingH,
                    ...css.rowCenterAlign,
                    marginBottom: sizes.space,
                  }}
                >
                  <Button
                    onPress={_onConfirmDesc}
                    title={{ value: strings.confirm }}
                    width={100}
                    bgColor={colors.success}
                    style={{ marginRight: sizes.space }}
                  />

                  <Button
                    onPress={_onCancelDesc}
                    title={{ value: strings.cancel }}
                    outline
                    width={100}
                    bgColor={colors.danger}
                  />
                </View>
              </ScrollView>
            </Modal>
          </>
        )}
      </>
    );
  };

  return (
    <>
      <Header
        title={strings.add_new_factor_item}
        leftIcon={{ name: "check", color: colors.theme, size: 28 }}
      />
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          ...css.responsiveInputsListContainer,
          paddingBottom: 60,
        }}
      >
        {_renderContent()}
        <DraftItems setIndexToBeRemoved={setIndexToBeRemoved} />
      </ScrollView>

      <Button
        absolute
        bottom={sizes.space}
        left={sizes.space}
        onPress={_goToBack}
        icon={{ name: "check", size: 25 }}
        square={45}
      />

      <View
        style={{
          padding: sizes?.space,
          ...css.rowCenterAlign,
          ...css.responsiveInputContainer,
        }}
      >
        {/* <Button onPress={_onSubmit} /> */}
      </View>

      <ConfirmAlert
        force
        hide={() => setIndexToBeRemoved(-1)}
        show={indexToBeRemoved !== -1}
        renderContent={(close) => (
          <DeleteAlertComponent
            cancel={close}
            removeLoading={false}
            remove={() => _onRemoveItem(close)}
          />
        )}
      />
    </>
  );
};

export default AddNewFactorItems;
